export default "__VITE_ASSET__GyD1Hj1h__"